import { render } from "./EditAlternativePage.vue?vue&type=template&id=d311785a&ts=true"
import script from "./EditAlternativePage.vue?vue&type=script&lang=ts"
export * from "./EditAlternativePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__